import { SalesJob } from "@/types/sales";
import { imageDimensions } from "./imageDimensions";
import { hiw1, hiw2, hiw3 } from "./gcsImagePaths";

export const salesPoints: string[] = [
  "Work directly with homeowners to find the right protection at the best price.",
  "Build a rewarding, scalable career helping members make confident decisions about their coverage.",
  "Thrive in a fast-paced environment with unlimited opportunity to grow, earn, and lead.",
  "Leverage world-class training, inbound leads, and leadership support to maximize your success.",
  "Join a culture that rewards results, values service over sales, and gives you the tools to do your best work.",
];

export const salesJobs: SalesJob[] = [
  {
    title: "Licensed Insurance Agent",
    applyUrl:
      "https://threeships.clockworkrecruiting.com/job_posts/6cf2c96d-631d-4e1c-aee1-db5f4189afaa",
    jobUrl:
      "https://threeships.clockworkrecruiting.com/job_posts/6cf2c96d-631d-4e1c-aee1-db5f4189afaa",
    description:
      "As a licensed insurance agent, you'll build strong client relationships, sell insurance policies, and contribute to a high-growth culture. You'll act as a trusted advisor, guiding clients through coverage options and securing the best protection for their needs. This is an exciting opportunity to leverage our steady pipeline of qualified leads and grow your own portfolio of business while contributing to the foundation of a successful company.",
    location: "Remote / Hybrid",
    type: "Full-Time",
    delay: "",
  },
];

export const hiw1Dim = imageDimensions[hiw1];
export const hiw2Dim = imageDimensions[hiw2];
export const hiw3Dim = imageDimensions[hiw3];
